module.exports = __webpack_public_path__ + "static/media/noble_speak.77801141.jpg";